var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "mt-1" }, [
      _c(
        "select",
        {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.newCountry,
              expression: "newCountry",
            },
          ],
          staticClass: "form-control",
          on: {
            change: [
              function ($event) {
                var $$selectedVal = Array.prototype.filter
                  .call($event.target.options, function (o) {
                    return o.selected
                  })
                  .map(function (o) {
                    var val = "_value" in o ? o._value : o.value
                    return val
                  })
                _vm.newCountry = $event.target.multiple
                  ? $$selectedVal
                  : $$selectedVal[0]
              },
              _vm.addNewCountry,
            ],
          },
        },
        [
          _c("option", { attrs: { value: "0" } }, [
            _vm._v("Выберите дополнительную страну"),
          ]),
          _vm._v(" "),
          _vm._l(_vm.$AllCountries, function (country) {
            return _c("option", { domProps: { value: country.id } }, [
              _vm._v(_vm._s(country.name)),
            ])
          }),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        _vm._l(_vm.details, function (country) {
          return !country || !country.to_delete
            ? _c("div", { staticClass: "input-group" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: country.name,
                      expression: "country.name",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: { disabled: "" },
                  domProps: { value: country.name },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(country, "name", $event.target.value)
                    },
                  },
                }),
                _vm._v(" "),
                _c("div", { staticClass: "input-group-append" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-outline-danger",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return _vm.removeCountry(country)
                        },
                      },
                    },
                    [_c("i", { staticClass: "icon-fa icon-fa-trash" })]
                  ),
                ]),
              ])
            : _vm._e()
        }),
        0
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }